module.exports = {
	// COMMON
	ILLEGAL_OPERATION: {
		CODE: '888.000.400',
		MESSAGE: '系統發生錯誤，請稍後再試',
	},
	INVALID_CLIENT_IP: {
		CODE: '888.000.403',
		MESSAGE: 'IP在黑名單',
	},
	// COMPANY
	COMPANY_IS_BLOCKED: {
		CODE: '888.001.403',
		MESSAGE: '公司已刪除',
	},
	COMPANY_NOT_FOUND: {
		CODE: '888.001.404',
		MESSAGE: '公司不存在',
	},
	COMPANY_DUPLICATED: {
		CODE: '888.001.409',
		MESSAGE: '公司名稱已存在',
	},
	CLIENT_IP_RULE_WHITE_LISTS_IP_DUPLICATED: {
		CODE: '888.001.410',
		MESSAGE: '已存在於白名單中',
	},
	CLIENT_IP_RULE_BLACK_LISTS_IP_DUPLICATED: {
		CODE: '888.001.411',
		MESSAGE: '已存在於黑名單中',
	},
	CLIENT_IP_RULE_NOT_FOUND: {
		CODE: '888.001.412',
		MESSAGE: 'IP白名單或黑名單不存在',
	},
	CLIENT_IP_RULE_INCORRECT_EXPIRED_AT: {
		CODE: '888.001.413',
		MESSAGE: '解除时间需大于目前时间',
	},
	KEYWORD_ALERT_NOT_FOUND: {
		CODE: '888.001.414',
		MESSAGE: '關鍵字不存在',
	},
	KEYWORD_ALERT_EXCEED: {
		CODE: '888.001.415',
		MESSAGE: '關鍵字已達上限',
	},
	INVALID_API_KEY: {
		CODE: '888.001.416',
		MESSAGE: 'API KEY無效',
	},
	INVALID_COMPANY_REQUEST: {
		CODE: '888.001.422',
		MESSAGE: '輸入格式錯誤',
	},
	// SERVICE SETTING
	AI_MODEL_NOT_FOUND: {
		CODE: '888.002.404',
		MESSAGE: '模型不存在',
	},
	AI_MODEL_DUPLICATED: {
		CODE: '888.002.409',
		MESSAGE: '所選項目已存在',
	},
	AI_MODEL_IN_USE: {
		CODE: '888.002.410',
		MESSAGE: '模型正被平台使用中',
	},
	INVALID_SERVICE_SETTING_REQUEST: {
		CODE: '888.002.422',
		MESSAGE: '輸入格式錯誤',
	},
	// PLATFORM
	PLATFORM_NOT_FOUND: {
		CODE: '888.003.404',
		MESSAGE: '平臺不存在',
	},
	CONVERSATION_TAG_NOT_FOUND: {
		CODE: '888.003.405',
		MESSAGE: '標籤不存在',
	},
	USER_PROFILE_SCHEMA_NOT_FOUND: {
		CODE: '888.003.406',
		MESSAGE: '自定義標籤不存在',
	},
	CONVERSATION_SEARCH_FILTER_NOT_FOUND: {
		CODE: '888.003.407',
		MESSAGE: '過濾器不存在',
	},
	FILE_NOT_FOUND: {
		CODE: '888.003.408',
		MESSAGE: '檔案不存在',
	},
	PLATFORM_DUPLICATED: {
		CODE: '888.003.409',
		MESSAGE: '平臺代碼已存在',
	},
	CONVERSATION_TAG_DUPLICATED: {
		CODE: '888.003.410',
		MESSAGE: '標籤代碼已存在',
	},
	USER_PROFILE_SCHEMA_DUPLICATED: {
		CODE: '888.003.411',
		MESSAGE: '自定義標籤已存在',
	},
	CONVERSATION_SEARCH_FILTER_NAME_DUPLICATED: {
		CODE: '888.003.412',
		MESSAGE: '過濾器名稱已存在',
	},
	WAITING_ALERT_NOT_FOUND: {
		CODE: '888.003.413',
		MESSAGE: '等待时间颜色设定不存在',
	},
	AI_API_KEY_NOT_FOUND: {
		CODE: '888.003.414',
		MESSAGE: '公司未設置API KEY，請聯繫管理員',
	},
	INVALID_PLATFORM_REQUEST: {
		CODE: '888.003.422',
		MESSAGE: '輸入格式錯誤',
	},
	FILE_TOO_LARGE: {
		CODE: '888.003.423',
		MESSAGE: '檔案過大',
	},
	IMAGE_SIZE_TOO_LARGE: {
		CODE: '888.003.424',
		MESSAGE: '圖片尺寸過大',
	},
	VIP_CLIENT_DUPLICATED: {
		CODE: '888.003.425',
		MESSAGE: '重要客户重复',
	},
	VIP_CLIENT_NOT_FOUND: {
		CODE: '888.003.426',
		MESSAGE: '重要客户不存在',
	},
	QUICK_ACTIONS_EXCEED: {
		CODE: '888.003.427',
		MESSAGE: '用戶快捷選單已達上限',
	},
	QUICK_ACTIONS_NOT_FOUND: {
		CODE: '888.003.428',
		MESSAGE: '用戶快捷選單不存在',
	},
	EITHER_MODEL_OR_FINE_TUNING_RECORD_ID: {
		CODE: '888.003.429',
		MESSAGE: '模型或微調記錄必須擇一',
	},
	MARQUEE_ITEMS_EXCEED: {
		CODE: '888.003.430',
		MESSAGE: '內容最多10组',
	},
	MARQUEE_NOT_FOUND: {
		CODE: '888.003.431',
		MESSAGE: '跑馬燈不存在',
	},
	BACKGROUND_IMAGE_SIZE_TOO_LARGE: {
		CODE: '888.003.432',
		MESSAGE: '上傳失敗，檔案大小不得超過1MB',
	},
	CONVERSATION_TAG_LAST_ENTRANCE_TAG: {
		CODE: '888.003.433',
		MESSAGE: '沒有其他進入標籤被開啟，故無法關閉此進入標籤',
	},
	CONVERSATION_TAG_DELETE_LAST_ENTRANCE_TAG: {
		CODE: '888.003.434',
		MESSAGE: '沒有其他進入標籤被開啟，故無法刪除此標籤',
	},
	TRANSLATION_API_KEY_NOT_FOUND: {
		CODE: '888.003.435',
		MESSAGE: '公司未設定翻譯 API Key，請聯絡管理員',
	},
	PLATFORM_USING_AUTO_LANGUAGE_CODE: {
		CODE: '888.003.436',
		MESSAGE: '目前有啟用中的偵測語言平台，無法關閉',
	},
	CLIENT_HISTORY_NOT_FOUND: {
		CODE: '888.003.437',
		MESSAGE: '履历不存在',
	},
	PROMPT_TYPE_NOT_FOUND: {
		CODE: '888.003.438',
		MESSAGE: '推播類型不存在',
	},
	PROMPT_NOT_FOUND: {
		CODE: '888.003.439',
		MESSAGE: '推播不存在',
	},
	PROMPT_LIMIT_EXCEED: {
		CODE: '888.003.440',
		MESSAGE: '推播已達上限',
	},
	PROMPT_NAME_DUPLICATED: {
		CODE: '888.003.441',
		MESSAGE: '推播標題已存在',
	},
	PROMPT_TYPE_LIMIT_EXCEED: {
		CODE: '888.003.442',
		MESSAGE: '推播類型已達上限',
	},
	PROMPT_TYPE_DUPLICATED: {
		CODE: '888.003.443',
		MESSAGE: '推播類型已存在',
	},
	PROMPT_TYPE_CAN_NOT_BE_DELETED: {
		CODE: '888.003.444',
		MESSAGE: '該類型目前有推播訊息套用中，無法刪除',
	},
	INVALID_PROMPT_INTERVAL: {
		CODE: '888.003.445',
		MESSAGE: '時間設定需至少為 3 分鐘',
	},
	SYNONYM_TERM_DUPLICATED: {
		CODE: '888.003.446',
		MESSAGE: '內容有重複字[{0}]',
	},
	SYNONYM_NOT_FOUND: {
		CODE: '888.003.447',
		MESSAGE: '同義詞不存在',
	},
	AI_SYSTEM_PROMPT_USER_PROFILE_FIELD_DUPLICATED: {
		CODE: '888.003.448',
		MESSAGE: '已存在「{0}」',
	},
	AI_SYSTEM_PROMPT_USER_PROFILE_FIELDS_EXCEED: {
		CODE: '888.003.449',
		MESSAGE: '最多可新增50個，已超過上限',
	},
	USER_CUSTOM_ICON_FILE_TOO_LARGE: {
		CODE: '888.003.450',
		MESSAGE: '檔案最大500K',
	},
	USER_CUSTOM_ICON_EXCEED: {
		CODE: '888.003.451',
		MESSAGE: '已達上傳上限 30 張',
	},
	USER_CUSTOM_ICON_IN_USE: {
		CODE: '888.003.452',
		MESSAGE: '此圖像正在使用中，無法刪除',
	},
	FILE_DOWNLOAD_FAILED: {
		CODE: '888.003.453',
		MESSAGE: '檔案下載失敗',
	},
	CLIENT_REPLY_RATE_LIMIT_MESSAGE_EXCEED: {
		CODE: '888.003.454',
		MESSAGE: '不可輸入超過200字',
	},
	AI_API_KEY_SERIES_NOT_ENABLED: {
		CODE: '888.003.455',
		MESSAGE: '公司未啟用對應AI系列，請聯繫管理員',
	},
	PLATFORM_NOT_BLOCKED: {
		CODE: '888.003.456',
		MESSAGE: '平台啟用中，請先停用平台後再刪除',
	},
	// ROLE
	ROLE_NOT_FOUND: {
		CODE: '888.004.404',
		MESSAGE: '角色不存在',
	},
	ROLE_NAME_DUPLICATED: {
		CODE: '888.004.409',
		MESSAGE: '角色名稱已存在',
	},
	ROLE_PLATFORM_HAS_DESCENDANTS: {
		CODE: '888.004.410',
		MESSAGE: '此角色平臺有下級存在，無法進行刪除',
	},
	ROLE_HAS_DESCENDANTS: {
		CODE: '888.004.411',
		MESSAGE: '此角色有下級存在，無法進行刪除',
	},
	ROLE_HAS_USER: {
		CODE: '888.004.412',
		MESSAGE: '已有帳號使用中，無法刪除',
	},
	INVALID_ROLE_REQUEST: {
		CODE: '888.004.422',
		MESSAGE: '輸入格式錯誤',
	},
	// GROUP
	GROUP_NOT_FOUND: {
		CODE: '888.005.404',
		MESSAGE: '團隊不存在',
	},
	GROUP_DUPLICATED: {
		CODE: '888.005.409',
		MESSAGE: '團隊名稱已存在',
	},
	INVALID_GROUP_REQUEST: {
		CODE: '888.005.422',
		MESSAGE: '輸入格式錯誤',
	},
	// QA
	QA_NODE_LAYER_EXCEEDED: {
		CODE: '888.006.403',
		MESSAGE: '問題階層已滿',
	},
	QA_NODE_NOT_FOUND: {
		CODE: '888.006.404',
		MESSAGE: '問題不存在',
	},
	QA_TREE_NOT_FOUND: {
		CODE: '888.006.405',
		MESSAGE: '智能客服不存在',
	},
	QA_NODE_OPTION_LEAF_CHILD_IDS_EMPTY: {
		CODE: '888.006.406',
		MESSAGE: '問題階層的最後一層不得為選項，請重新選擇',
	},
	INVALID_QA_NODE_TYPE: {
		CODE: '888.006.407',
		MESSAGE: '問題類別不符',
	},
	QA_NODE_CAN_NOT_BE_UPDATED: {
		CODE: '888.006.408',
		MESSAGE: '問題無法被修改',
	},
	QA_NODE_DUPLICATED: {
		CODE: '888.006.409',
		MESSAGE: '問題已存在',
	},
	QA_NODE_CAN_NOT_BE_DELETED: {
		CODE: '888.006.410',
		MESSAGE: '問題無法被刪除',
	},
	INVALID_QA_OPTIONS: {
		CODE: '888.006.411',
		MESSAGE: '此問題無此選項',
	},
	QA_NODE_OPTION_CAN_NOT_BE_EMPTY: {
		CODE: '888.006.412',
		MESSAGE: '{0}',
	},
	QA_CHARGE_FORM_TITLE_CAN_NOT_BE_EDITED: {
		CODE: '888.006.413',
		MESSAGE: '不可變更充值表單標題',
	},
	QA_COMMON_INFORMATION_NOT_FOUND: {
		CODE: '888.006.414',
		MESSAGE: '共同資訊不存在',
	},
	QA_COMMON_INFORMATION_CAN_NOT_DELETE: {
		CODE: '888.006.415',
		MESSAGE: '已設置於其他答案，無法刪除',
	},
	INVALID_QA_REQUEST: {
		CODE: '888.006.422',
		MESSAGE: '輸入格式錯誤',
	},
	// MANAGEMENT_LOG
	TOOL_API_LOG_NOT_FOUND: {
		CODE: '888.009.404',
		MESSAGE: 'API 傳送日誌不存在',
	},
	INVALID_MANAGEMENT_LOG_REQUEST: {
		CODE: '888.009.422',
		MESSAGE: '輸入格式錯誤',
	},
	// AUTH
	INVALID_LOGIN_CREDENTIALS: {
		CODE: '888.010.401',
		MESSAGE: '帳密錯誤',
	},
	WITHOUT_LOGGED_IN: {
		CODE: '888.010.402',
		MESSAGE: '請先登入',
	},
	INVALID_LOGIN_IP: {
		CODE: '888.010.403',
		MESSAGE: 'IP位址不符合',
	},
	INVALID_GOOGLE_TOTP: {
		CODE: '888.010.404',
		MESSAGE: '谷歌驗證碼錯誤',
	},
	INVALID_PASSWORD_OR_GOOGLE_TOTP: {
		CODE: '888.010.405',
		MESSAGE: '帳密或谷歌驗證碼錯誤',
	},
	WITHOUT_GOOGLE_TOTP_LOGGED_IN: {
		CODE: '888.010.406',
		MESSAGE: '尚未完成谷歌驗證',
	},
	AUTH_UNBIND_GOOGLE_TOTP_CREDENTIALS: {
		CODE: '888.010.407',
		MESSAGE: '尚未綁定谷歌驗證',
	},
	AUTH_TOKEN_INVALID: {
		CODE: '888.010.408',
		MESSAGE: 'Token 失效',
	},
	AUTH_TOKEN_TYPE_INVALID: {
		CODE: '888.010.409',
		MESSAGE: '包網登入端口不符',
	},
	INVALID_AUTH_REQUEST: {
		CODE: '888.010.422',
		MESSAGE: '輸入格式錯誤',
	},
	// STATS
	INVALID_STATS_REQUEST: {
		CODE: '888.011.422',
		MESSAGE: '輸入格式錯誤',
	},
	// USER
	USER_WRONG_OLD_PASSWORD: {
		CODE: '888.012.401',
		MESSAGE: '舊登入密碼錯誤',
	},
	USER_IS_BLOCKED: {
		CODE: '888.012.402',
		MESSAGE: '帳戶被凍結',
	},
	USER_PASSWORD_IS_UPDATED: {
		CODE: '888.012.403',
		MESSAGE: '登入密碼已更新，請重新登入',
	},
	USER_NOT_FOUND: {
		CODE: '888.012.404',
		MESSAGE: '用戶不存在',
	},
	USER_IS_FORBIDDEN: {
		CODE: '888.012.405',
		MESSAGE: '用戶無此權限',
	},
	USER_NEW_PASSWORD_EQUAL_TO_OLD_PASSWORD: {
		CODE: '888.012.406',
		MESSAGE: '新密碼不能設置與舊密碼相同',
	},
	USER_WITHOUT_LOGGED_IN: {
		CODE: '888.012.407',
		MESSAGE: '請先登入',
	},
	USER_IS_UPDATED: {
		CODE: '888.012.408',
		MESSAGE: '帳號異動，請重新登入',
	},
	USER_DUPLICATE_USERNAME: {
		CODE: '888.012.409',
		MESSAGE: '帳號已存在',
	},
	USER_DUPLICATE_DISPLAY_NAME: {
		CODE: '888.012.410',
		MESSAGE: '暱稱已存在',
	},
	COMPANY_ACCOUNT_NOT_FOUND: {
		CODE: '888.012.414',
		MESSAGE: '公司帳號不存在',
	},
	USER_NEW_ROLE_EQUAL_TO_OLD_ROLE: {
		CODE: '888.012.415',
		MESSAGE: '新角色不能設置與舊角色相同',
	},
	GOOGLE_TOTP_IS_CREATED: {
		CODE: '888.012.416',
		MESSAGE: '谷歌驗證已綁定',
	},
	GOOGLE_TOTP_IS_NOT_CREATED: {
		CODE: '888.012.417',
		MESSAGE: '尚未綁定谷歌驗證',
	},
	TOO_MUCH_PLATFORM_SETS: {
		CODE: '888.012.418',
		MESSAGE: '已储存超过五个版本',
	},
	USER_PLATFORM_SET_DUPLICATED: {
		CODE: '888.012.419',
		MESSAGE: '版本名称重复',
	},
	LAST_PLATFORM_SET_NOT_FOUND: {
		CODE: '888.012.420',
		MESSAGE: '上一次变更平台的资料不存在',
	},
	BW_USER_IS_FORBIDDEN: {
		CODE: '888.012.421',
		MESSAGE: '包网使用者无权限操作',
	},
	USER_INVALID_REQUEST: {
		CODE: '888.012.422',
		MESSAGE: '輸入格式錯誤',
	},
	IP_NOT_MATCH_ANY_ONE: {
		CODE: '888.012.423',
		MESSAGE: 'IP 不在 IP 白名单内',
	},
	USER_NO_AVAILABLE_USER: {
		CODE: '888.012.424',
		MESSAGE: '没有其他工作中人员，无法操作',
	},
	USER_LOGOUT_WARNING_HAS_ACTIVE_CONVERSATION: {
		CODE: '888.012.425',
		MESSAGE: '仍有服务中对话，请转接/结束对话后再操作',
	},
	// 當下客服有接待中的對話(自己對話協作給他人的情況不算在內)
	USER_ON_BREAK_WARNING_HAS_ACTIVE_CONVERSATION: {
		CODE: '888.012.426',
		MESSAGE: '仍有服务中对话，请协作/转接/结束对话后再操作',
	},
	// 當下客服有參與協作他人的對話
	USER_ON_BREAK_WARNING_HAS_JOIN_CONVERSATION: {
		CODE: '888.012.427',
		MESSAGE: '仍有参与协作中的对话，请离开对话后再操作',
	},
	BW_USER_CAN_NOT_BE_UPDATED: {
		CODE: '888.012.428',
		MESSAGE: '无法操作包网使用者',
	},
	// QUICK REPLY CATEGORY
	QUICK_REPLY_CATEGORY_TYPE_IS_IMAGE: {
		CODE: '888.013.403',
		MESSAGE: '此分類為常用圖片',
	},
	QUICK_REPLY_CATEGORY_NOT_FOUND: {
		CODE: '888.013.404',
		MESSAGE: '快捷語分類不存在',
	},
	QUICK_REPLY_OR_IMAGE_NOT_FOUND: {
		CODE: '888.013.405',
		MESSAGE: '快捷語或常用圖片不存在',
	},
	QUICK_REPLY_NOT_FOUND: {
		CODE: '888.013.406',
		MESSAGE: '快捷語不存在',
	},
	QUICK_REPLY_CATEGORY_TYPE_IS_TEXT: {
		CODE: '888.013.407',
		MESSAGE: '此分類為快捷語',
	},
	QUICK_REPLY_IMAGE_NOT_FOUND: {
		CODE: '888.013.408',
		MESSAGE: '常用圖片不存在',
	},
	EXCHANGE_QUICK_REPLY_CATEGORY_ORDER_DUPLICATED: {
		CODE: '888.013.409',
		MESSAGE: '不得與自己交換',
	},
	QUICK_REPLY_CATEGORY_MODIFIED: {
		CODE: '888.013.410',
		MESSAGE: '快捷語分類更新，請重新操作',
	},
	INVALID_QUICK_REPLY_CATEGORY_REQUEST: {
		CODE: '888.013.422',
		MESSAGE: '輸入格式錯誤',
	},
	// CONVERSATION
	INVALID_CONVERSATION_STATUS: {
		CODE: '888.014.003',
		MESSAGE: '此狀態不能回覆',
	},
	CONVERSATION_NOT_FOUND: {
		CODE: '888.014.404',
		MESSAGE: '對話不存在',
	},
	CONVERSATION_REPLY_NOT_FOUND: {
		CODE: '888.014.405',
		MESSAGE: '訊息不存在',
	},
	CONVERSATION_NOT_CLOSED: {
		CODE: '888.014.406',
		MESSAGE: '對話尚未結束',
	},
	CONVERSATION_EXIST: {
		CODE: '888.014.409',
		MESSAGE: '對話已存在',
	},
	CAPTCHA_NOT_FOUND: {
		CODE: '888.014.410',
		MESSAGE: '拼圖不存在',
	},
	INVALID_CAPTCHA: {
		CODE: '888.014.411',
		MESSAGE: '拼圖驗證失敗',
	},
	CAPTCHA_FAILED_TOO_MUCH_TIME: {
		CODE: '888.014.412',
		MESSAGE: '拼圖驗證失敗次數過多',
	},
	LOAD_DATA_DATE_RANGE_LIMIT: {
		CODE: '888.014.413',
		MESSAGE: 'LOAD DATA匯出範圍不可超過一個月',
	},
	LOAD_DATA_DATE_DOWNLOAD_LIMIT: {
		CODE: '888.014.414',
		MESSAGE: 'LOAD DATA匯出範圍不可超過一萬筆',
	},
	CONVERSATION_CANNOT_NAVIGATE_HOME: {
		CODE: '888.014.415',
		MESSAGE: '對話已開始處理，無法返回首頁',
	},
	INVALID_CONVERSATION_IP_FORMAT: {
		CODE: '888.014.416',
		MESSAGE: 'IP 格式錯誤，請重新輸入',
	},
	CONVERSATION_IP_NOT_FOUND: {
		CODE: '888.014.417',
		MESSAGE: '無對應IP，請重新搜尋',
	},
	CONVERSATION_REPLY_MONITOR_INTERCEPTED: {
		CODE: '888.014.418',
		MESSAGE: '對話仍處於AI攔截狀態，無法開啟AI客服',
	},
	CONVERSATION_REPLY_FILE_NOT_SHAREABLE: {
		CODE: '888.014.419',
		MESSAGE: '此檔案類型不支援生成分享鏈接',
	},
	CONVERSATION_REPLY_MONITOR_NOT_INTERCEPTED: {
		CODE: '888.014.420',
		MESSAGE: '此訊息未被AI攔截或已解除攔截',
	},
	CONVERSATION_REPLY_TRANSLATION_NOT_FAILED: {
		CODE: '888.014.421',
		MESSAGE: '此訊息翻譯未失敗，無法重新傳送',
	},
	INVALID_CONVERSATION_REQUEST: {
		CODE: '888.014.422',
		MESSAGE: '輸入格式錯誤',
	},
	CONVERSATION_RATE_LIMIT: {
		CODE: '888.014.429',
		MESSAGE: '发送消息过于频繁，可稍后再试',
	},
	// SOCKET
	COWORKER_EXCEEDED: {
		CODE: '888.015.403',
		MESSAGE: '可協作人數已滿',
	},
	INVITATION_NOT_FOUND: {
		CODE: '888.015.404',
		MESSAGE: '邀請不存在',
	},
	ACTIVE_AND_HAND_OVERING_CONVERSATION_EXISTED: {
		CODE: '888.015.405',
		MESSAGE: '部分平台還有對話尚未結束',
	},
	COWORKER_NOT_FOUND: {
		CODE: '888.015.406',
		MESSAGE: '該使用者非此對話協作者',
	},
	CAN_NOT_INVITE_MYSELF: {
		CODE: '888.015.407',
		MESSAGE: '協作/轉接無法邀請自己',
	},
	INVITATION_CONFLICTS: {
		CODE: '888.015.409',
		MESSAGE: '協作/轉接異動中，請重新操作',
	},
	COWORK_INVITATION_DUPLICATE: {
		CODE: '888.015.410',
		MESSAGE: '該使用者已收到協作邀請',
	},
	// REPORT
	REPORT_NOT_FOUND: {
		CODE: '888.016.404',
		MESSAGE: '邀請不存在',
	},
	INVALID_REPORT_REQUEST: {
		CODE: '888.016.422',
		MESSAGE: '輸入格式錯誤',
	},
	// FILE_SHARE
	INVALID_FILE_SHARE_REQUEST: {
		CODE: '888.017.422',
		MESSAGE: '輸入格式錯誤',
	},
	FILE_SHARE_LINK_NOT_FOUND: {
		CODE: '888.017.404',
		MESSAGE: '檔案不存在',
	},
	// ANALYTICS
	ANALYTICS_NOT_FOUND: {
		CODE: '888.024.404',
		MESSAGE: '平台不存在',
	},
	INVALID_ANALYTICS_REQUEST: {
		CODE: '888.024.422',
		MESSAGE: '輸入格式錯誤',
	},
	// IP_WHITELIST
	IP_WHITELIST_NOT_FOUND: {
		CODE: '888.022.404',
		MESSAGE: '白名单不存在',
	},
	IP_WHITELIST_DUPLICATED: {
		CODE: '888.022.409',
		MESSAGE: '白名单已存在',
	},
	IP_WHITELIST_INVALID_REQUEST: {
		CODE: '888.022.422',
		MESSAGE: '输入格式错误',
	},
	// PLATFORM_AUTH
	INVALID_PLATFORM_AUTH_REQUEST: {
		CODE: '888.025.422',
		MESSAGE: '輸入格式錯誤',
	},
	// API_LOG
	API_LOG_NOT_FOUND: {
		CODE: '888.026.404',
		MESSAGE: 'API接受日志不存在',
	},
	INVALID_API_LOG_REQUEST: {
		CODE: '888.026.422',
		MESSAGE: '輸入格式錯誤',
	},
	// FINE_TUNING_TRAINING_DATA
	FINE_TUNING_TRAINING_DATA_NOT_FOUND: {
		CODE: '888.028.404',
		MESSAGE: '訓練資料不存在',
	},
	INVALID_FINE_TUNING_TRAINING_DATA_REQUEST: {
		CODE: '888.028.422',
		MESSAGE: '輸入格式錯誤',
	},
	INVALID_FINE_TUNING_TRAINING_DATA_LAST_ROLE: {
		CODE: '888.028.423',
		MESSAGE: '文本最后角色需为AI或客服人员',
	},
	FINE_TUNING_TRAINING_DATA_FILE_TOO_LARGE: {
		CODE: '888.003.423',
		MESSAGE: '汇入微调文本失败,档案大小不得超过400MB',
	},
	// FINE_TUNING_RECORD
	FINE_TUNING_RECORD_NOT_FOUND: {
		CODE: '888.029.404',
		MESSAGE: '微調訓練紀錄不存在',
	},
	INVALID_FINE_TUNING_RECORD_REQUEST: {
		CODE: '888.029.422',
		MESSAGE: '輸入格式錯誤',
	},
	// FRONTEND_LOG
	INVALID_FRONTEND_LOG_REQUEST: {
		CODE: '888.030.422',
		MESSAGE: '輸入格式錯誤',
	},
	// CLIENT AUTH
	INVALID_PLATFORM_CODE_REQUEST: {
		CODE: '403',
		MESSAGE: 'code錯誤',
	},
	INVALID_SIGNATURE: {
		CODE: '405',
		MESSAGE: '驗證錯誤',
	},
	DECRYPT_ERROR: {
		CODE: '406',
		MESSAGE: '解密錯誤',
	},
	TIMESTAMP_TIMEOUT: {
		CODE: '407',
		MESSAGE: '驗證時間超時',
	},
	PLATFORM_UNDER_MAINTENANCE: {
		CODE: '408',
		MESSAGE: '平台維護中',
	},
	SERVICE_UNDER_MAINTENANCE: {
		CODE: '409',
		MESSAGE: '伺服器維護中',
	},
	API_KEY_INVALID: {
		CODE: '410',
		MESSAGE: 'API KEY失效',
	},
};
